module.exports = __webpack_public_path__ + "static/sport/out3.e388f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/out3.png
// module id = lzGP
// module chunks = 0